import Routes from '../constants/routes'
import { INSTANT_FEEDBACK_TYPES } from '../constants/instant-feedback-types'
import { message } from 'antd'
import {
    CATALOG_ITEM_ID_PARAM,
    FILE_TOKEN_PARAM,
    FILE_TOKENS_PARAM,
    PROBLEM_SET_ID_PARAM,
    TOKEN_PARAM,
    USER_ID_PARAM,
    VERSION_ID_PARAM,
} from '../constants/query-params'
import _, { isNil } from 'lodash'
import { AssignmentSections } from '../constants/assignment-sections'
import { environmentToClarityProjectId } from '../constants/environments'

const baseUrl = `${window.location.protocol}//${window.location.host}`

export const buildAuthorizedFeedbackLink = (token, versionId, fileToken, fileTokens, catalogItemId) =>
    `${baseUrl}${Routes.INSTANT_FEEDBACK}?t=${INSTANT_FEEDBACK_TYPES.SUBMISSION}&${TOKEN_PARAM}=${token}${
        _.isNil(versionId) ? '' : `&${VERSION_ID_PARAM}=${versionId}`
    }${isNil(fileToken) ? '' : `&${FILE_TOKEN_PARAM}=${fileToken}`}${
        isNil(fileTokens) ? '' : `&${FILE_TOKENS_PARAM}=${fileTokens}`
    }${catalogItemId ? `&${CATALOG_ITEM_ID_PARAM}=${catalogItemId}` : ''}`
export const buildAnonymousFeedbackLink = (token, versionId) =>
    `${baseUrl}${Routes.INSTANT_FEEDBACK}?t=${INSTANT_FEEDBACK_TYPES.PRESUBMISSION}&${TOKEN_PARAM}=${token}${
        _.isNil(versionId) ? '' : `&${VERSION_ID_PARAM}=${versionId}`
    }`
export const buildAccessCodeFeedbackLink = (token, versionId) =>
    `${baseUrl}${Routes.INSTANT_FEEDBACK}?t=${INSTANT_FEEDBACK_TYPES.ACCESS_CODE}&${TOKEN_PARAM}=${token}${
        _.isNil(versionId) ? '' : `&${VERSION_ID_PARAM}=${versionId}`
    }`
export const buildProblemSetLink = (problemSetId, token) =>
    `${baseUrl}${Routes.INSTANT_FEEDBACK}?t=${INSTANT_FEEDBACK_TYPES.PRESUBMISSION}&${TOKEN_PARAM}=${token}&${PROBLEM_SET_ID_PARAM}=${problemSetId}`
export const buildAssignmentPath = (token, layerId, section = AssignmentSections.HOME, versionId) =>
    `${Routes.ASSIGNMENTS}/${token}/${layerId}/${section}${_.isNil(versionId) ? '' : `?${VERSION_ID_PARAM}=${versionId}`}`
export const buildAssignmentSectionPath = (token, section, layerId, versionId) =>
    `${Routes.ASSIGNMENTS}/${token}/${layerId}/${section}${_.isNil(versionId) ? '' : `?${VERSION_ID_PARAM}=${versionId}`}`
export const buildAssignmentLink = (token, layerId, versionId) =>
    `${baseUrl}${buildAssignmentPath(token, layerId, versionId)}`

export const buildClarityLinkToRecord = studentId => {
    const clarityProjectId = environmentToClarityProjectId(window.location.host)

    return `https://clarity.microsoft.com/projects/view/${clarityProjectId}/dashboard?URL=2%3B2%3B${USER_ID_PARAM}%3D${studentId}`
}

export const copyToClipboard = (stringToCopy, feedbackText = 'Copied to clipboard 🎉') => {
    navigator.clipboard.writeText(stringToCopy)
    message.success(feedbackText)
}

export const copyAuthorizedFeedbackLinkToClipboard = token => {
    copyToClipboard(buildAuthorizedFeedbackLink(token))
}

export const copyAnonymousFeedbackLinkToClipboard = token => {
    copyToClipboard(buildAnonymousFeedbackLink(token))
}

export const copyAccessCodeFeedbackLinkToClipboard = token => {
    copyToClipboard(buildAccessCodeFeedbackLink(token))
}

export const copyProblemSetLinkToClipboard = (problemSetId, token) => {
    copyToClipboard(buildProblemSetLink(problemSetId, token))
}

export const isCurrentRoute = route => window.location.pathname === route

export const updateSearchParams = (wantedParams, navigate) => {
    let params = new URLSearchParams(window.location.search)
    Object.keys(wantedParams).map(key => params.set(key, wantedParams[key]))
    navigate({ pathname: location.pathname, search: params.toString() })
}
